import { catalogPageConfigHandlers } from 'app/src/msw/catalogpageconfig'
import { catalogSummaryHandlers } from 'app/src/msw/catalogsummary'
import { companyagreementHandlers } from 'app/src/msw/companyagreement/api'
import { staticCompanyagreementHandlers } from 'app/src/msw/companyagreement/staticapi'
import { contactUsHandlers } from 'app/src/msw/contacts'
import { documentAiHandlers } from 'app/src/msw/documentai'
import { homepageConfigHandlers } from 'app/src/msw/homepageconfig'
import { i18nHandlers } from 'app/src/msw/i18n'
import { joinStepsHandlers } from 'app/src/msw/joinsteps'
import { mealvouchersHandlers } from 'app/src/msw/mealvouchers'
import { mealvouchersAuthHandlers } from 'app/src/msw/mealvouchers-auth'
import { membershipHandlers } from 'app/src/msw/membership/api'
import { staticMembershipHandlers } from 'app/src/msw/membership/staticapi'
import { moneytransferHandlers } from 'app/src/msw/moneytransfer/api'
import { staticMoneytransferHandlers } from 'app/src/msw/moneytransfer/staticapi'
import { newsHandlers } from 'app/src/msw/news'
import { portalConfigHandlers } from 'app/src/msw/portalconfig'
import { proposalsHandlers } from 'app/src/msw/proposals'
import { proposalsPageConfigHandlers } from 'app/src/msw/proposalspageconfig'
import { refundHandlers } from 'app/src/msw/refund/api'
import { staticRefundHandlers } from 'app/src/msw/refund/staticapi'
import { shoppingHandlers } from 'app/src/msw/shopping/api'
import { staticShoppingHandlers } from 'app/src/msw/shopping/staticapi'
import { mockImagesHandler } from 'app/src/msw/stories/common-stories-mock'
import { tutorialPageConfigHandlers } from 'app/src/msw/tutorialpageconfig'
import { tutorialsHandlers } from 'app/src/msw/tutorials'
import { useraccountpageConfigHandlers } from 'app/src/msw/useraccountpageconfig'
import { userinfopageConfigHandlers } from 'app/src/msw/userinfopageconfig'
import { userjoinpageConfigHandlers } from 'app/src/msw/userjoinpageconfig'
import { welfareDetailsHandlers } from 'app/src/msw/welfaredetails'
import type { HttpHandler } from 'msw'

/**
 * Function to get common MSW handlers for both msw:start and storybook
 * @returns common handlers
 */
function commonMswHandlers(): HttpHandler[] {
  return [
    ...i18nHandlers,
    ...documentAiHandlers,
    ...contactUsHandlers,
    ...homepageConfigHandlers,
    ...welfareDetailsHandlers,
    ...catalogSummaryHandlers,
    ...catalogPageConfigHandlers,
    ...useraccountpageConfigHandlers,
    ...tutorialPageConfigHandlers,
    ...portalConfigHandlers,
    ...newsHandlers,
    ...tutorialsHandlers,
    ...userjoinpageConfigHandlers,
    ...joinStepsHandlers,
    ...mealvouchersHandlers,
    ...mealvouchersAuthHandlers,
    ...userinfopageConfigHandlers,
    ...proposalsPageConfigHandlers,
    ...proposalsHandlers,
  ]
}

/**
 * Function to get MSW handlers for msw:start command including collections
 * @returns dev handlers
 */
function getMswHandlers(): HttpHandler[] {
  return [
    ...commonMswHandlers(),
    ...membershipHandlers, // with DB > staticMembershipHandlers
    ...moneytransferHandlers, // with DB > staticMoneytransferHandlers
    ...refundHandlers, // with DB > staticRefundHandlers
    ...shoppingHandlers, // with DB
    ...companyagreementHandlers, // with DB
  ]
}

/**
 * Function to get MSW handlers for storybook without collections
 * @returns static handlers
 */
function getStaticMswHandlers(): HttpHandler[] {
  return [
    ...commonMswHandlers(),
    ...staticMembershipHandlers,
    ...staticMoneytransferHandlers,
    ...staticRefundHandlers,
    ...staticShoppingHandlers,
    ...staticCompanyagreementHandlers,
    ...mockImagesHandler,
  ]
}

export { getMswHandlers, getStaticMswHandlers }
